var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mounting-portal",
    { attrs: { "mount-to": "#order-widget-target-modern" } },
    [
      _c("div", { staticClass: "layout-landingpage__order-widgets" }, [
        _c("h2", { staticClass: "mt-4" }, [
          _vm._v(_vm._s(_vm.$t("landingpage:orderwidget.title"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "order-widgets" },
          [
            _vm.orderWidget == null
              ? _vm._l(_vm.MAX_DUMMY_ORDER_WIDGET_BOXES, function (index) {
                  return _c(
                    "order-widget-box",
                    {
                      key: "mock-" + index,
                      attrs: {
                        "widget-index": index - 1,
                        "widget-item": _vm.mockWidget,
                      },
                    },
                    [
                      _c("loading-animation", {
                        attrs: {
                          "loading-title": _vm.$t(
                            "landingpage:orderwidget.loading.title"
                          ),
                          "display-type": "blocking",
                        },
                      }),
                    ],
                    1
                  )
                })
              : _vm._l(_vm.orderWidget, function (widget, index) {
                  return _c("order-widget-box", {
                    key: index,
                    attrs: {
                      "widget-index": index,
                      "widget-item": widget,
                      "is-selected": _vm.currentSelectedOrderWidget === index,
                    },
                    on: {
                      "click:orderwidget": function ($event) {
                        return _vm.onOrderWidgetSelected($event, index)
                      },
                    },
                  })
                }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "order-widget order-widget--create d-flex flex-column",
                style: {
                  "background-image":
                    "url(" + _vm.customBundleBackgroundImage + ")",
                },
                attrs: { tabindex: "-1" },
                on: { click: _vm.onCustomOrderWidgetClick },
              },
              [
                _c(
                  "div",
                  { staticClass: "order-widget__wrapper mb-auto mt-auto" },
                  [
                    _c(
                      "span",
                      { staticClass: "order-widget__slots text-uppercase" },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("landingpage:orderwidget.custom.title"))
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button button--tiny order-widget__order-button text-center",
                      attrs: { href: _vm.orderUrl },
                      on: { click: _vm.orderTracking },
                    },
                    [_vm._v(_vm._s(_vm.$t("general:non_special_texts.order")))]
                  ),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }